// Slightly modified Pancakes smart contract
import masterChefIdexABI from 'config/abi/masterchefIdex.json';
import masterchefMultiRewardsABI from 'config/abi/masterchefMultiRewards.json';

export { masterChefIdexABI, masterchefMultiRewardsABI };

export default masterChefIdexABI;
